/**
 * Set once the stale-bundle handler (main.tsx `vite:preloadError`) has asked the browser
 * to reload. From then until the page unloads, errors are fallout, not signal: with the
 * preload error `preventDefault()`-ed, Vite resolves the lazy route import to `undefined`
 * and TanStack throws "Cannot read properties of undefined (reading 'component')" /
 * Safari's "undefined is not an object (evaluating 'e[t??`default`]')" (Sentry BDAY-WEB-5,
 * -6, -9 — bursts after every deploy, 2026-10-21). Sentry's beforeSend and the router's
 * onCatch both check this and stay quiet while the reload is in flight.
 */
let reloadPending = false;

export function markReloadPending(): void {
  reloadPending = true;
}

export function isReloadPending(): boolean {
  return reloadPending;
}
